import { Employee, ApiEmployee } from '../types/employee.ts';

export const mapApiEmployeeToEmployee = (apiEmployee: ApiEmployee): Employee => {
  return {
    id: apiEmployee.id.toString(),
    name: apiEmployee.name,
    email: apiEmployee.email,
    role: apiEmployee.role,
    associateType: apiEmployee.associate_type,
    createdBy: apiEmployee.created_by,
    createdAt: new Date(apiEmployee.created_at),
  };
};

export const mapEmployeeToApiEmployee = (employee: Employee): ApiEmployee => {
  return {
    id: parseInt(employee.id),
    name: employee.name,
    email: employee.email,
    role: employee.role,
    associateType: employee.associate_type,
    createdBy: employee.created_by,
    createdAt: employee.created_at.toISOString(),
  };
};